import React, { useEffect, useRef, useState } from "react";
import { FaLongArrowAltRight } from "@react-icons/all-files/fa/FaLongArrowAltRight";
import { FaCheck } from "@react-icons/all-files/fa/FaCheck";
// import breaks from "../../../../../assets/videos/breaks.mp4";
import bracks1 from "../../../../../assets/image/category/bracks1.webp";
import maintenance from "../../../../../assets/image/services/maintenance.jpg";
import break4 from "../../../../../assets/image/services/break4.webp";
import material from "../../../../../assets/image/services/material.jpg";
import damage from "../../../../../assets/image/services/damage.jpg";
import overlay from "../../../../../assets/image/overlay.jpg";
import check from "../../../../../assets/image/check.png";
import { Link } from "react-router-dom";
import MyButton from "../../utils/Button/MyButton";
export default function Breaks() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    // Trigger animation after component mounts
    setTimeout(() => setIsVisible(true), 100);
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
  }, []);
  return (
    <>
      {/*  Brake Services*/}

      <div className="text-black lg:w-full md:w-full  lg:pb-[0px] overflow-hidden ">
        {/* Image Column (5/12 on large) */}
        <div className="  relative flex flex-col w-full justify-center text-center items-center  ">
          <img
            className="  lg:h-[30rem] h-[19rem] md:h-[25rem]  w-[100%] lg:bg-cover lg:pe-0 md:pe-0 object-cover"
            src={bracks1}
            alt="breaks"
          />
          <div class="absolute inset-0 bg-gradient-to-t from-[#2770ab]/65 to-transparent"></div>
          <h3
            className={`text-gray-100  font-bold lg:text-6xl md:text-4xl absolute text-center lg:mb-20 md:mb-10 mb-16 
          transition-all duration-[5000ms] ease-out
                ${isVisible ? "opacity-100" : "opacity-0"}
              `}
          >
            VAP Brakes Services
          </h3>
          <div
            className={`w-full text-center mx-auto flex items-start justify-center lg:mt-12 md:mt-12 mt-10 absolute 
           transition-all duration-[1050ms] ease-out
                ${
                  isVisible
                    ? "-translate-y-0 opacity-100"
                    : "translate-y-5 opacity-0"
                }
              `}
          >
            <Link to="/contact-us">
              {/* <button className="p-2 rounded text-orange-500 bg-orange-500 text-white cursor-pointer">
                Book Now
              </button> */}
              <MyButton
                text=" Brake Services"
                className="bg-orange-500 text-white py-[12px]  rounded-full text-base sm:text-lg md:text-xl font-bold transform transition-transform duration-500 hover:scale-105 mt-3 shadow-md"
              />
            </Link>
          </div>
        </div>

        {/* Content Column (7/12 on large) */}
        <div className="bg-gradient-to-b from-white to-[#F8FAFC] py-[33px] lg:px-[12%] ">
          <div className="container mx-auto px-6 max-w-4xl  text-center ">
            <p className="text-xl lg:block hidden   text-gray-700 mb-6 leading-relaxed">
              Is your vehicle taking longer to stop or making unusual noises
              when you brake? These could be signs of worn-out brake pads issues
              in your braking system. Ignoring them can lead to costly
              repairs—or worse, unsafe driving conditions.
            </p>
            <p className=" text-gray-700 mb-6 text-xl   leading-relaxed">
              Don't wait until it's too late. Schedule your{" "}
              <strong className="text-gray-900">FREE brake inspection</strong>{" "}
              today for peace of mind, confidence, and safety. Our certified
              technicians will check your entire braking system to make sure
              everything is working properly and keep you safe on the road.
            </p>
          </div>
          <div
            className={`
           transition-all duration-[950ms] delay-[2500ms] ease-in-out
                ${
                  isVisible
                    ? "-translate-y-0 opacity-100"
                    : "translate-y-5 opacity-0"
                }
              `}
          >
            <Link to="/contact-us">
              {/* <button className="p-2 rounded text-orange-500 bg-orange-500 text-white cursor-pointer">
                Book Now
              </button> */}
              <MyButton
                text="Book Now"
                className="mx-auto transform px-2 text-center transition-transform duration-500 hover:scale-105"
              />
            </Link>
          </div>
        </div>
      </div>

      <div className="bg-[#EFF6FF]">
        <div className=" py-[30px]  container  ">
          <h1 className="text-blue-900 font-bold  text-[2.23rem] md:text-[2.6rem] lg:text-[3rem]  mb-3 text-center">
            Our Brake Services
          </h1>
          <p className="mb-3 lg:font-normal text-[1.35rem] text-center  lg:px-[9%]  ">
            Your vehicle's braking system is a complex network of components
            working together to keep you safe. When one part begins to fail, it
            affects the entire system. Our skilled technicians provide expert
            service for a wide range of models, using only high-quality parts.
          </p>
          <div className="flex justtify-center items-center lg:px-[5%]  sm:px-2 ">
            <div className="text-black text-center  h-[100%]  ">
              {/* first */}
              <div className=" flex lg:flex-row md:flex-col flex-col w-full max-h-[50%] my-[4%] justify-between  ">
                <div className="lg:w-[50%] md:w-[97%] w-full lg:mb-0 mb-2 ">
                  <img
                    src={damage}
                    alt=""
                    className="rounded-[4%] border-none outline-none box-s lg:w-[31rem]   lg:h-[22rem] md:h-[80%] h-[17rem]  w-full object-cover  "
                  />
                </div>

                <div className=" lg:text-start md:text-start sm:text-center lg:min-h-[30%] md:min-h-[10%] my-auto lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] text-3xl tracking-tight ">
                    <b>
                      Don’t Ignore{" "}
                      <span className="text-[#2772AD]">Vehicle Parts</span>
                    </b>
                  </p>
                  <p className="lg:font-normal text-gray-700  text-[1.24rem]">
                    A single overlooked part—like a faulty hose, belt, or
                    seal—can lead to catastrophic failure across your entire
                    system. That slow leak or warning light may seem minor, but
                    it can quickly escalate into major engine damage. What
                    starts as a small issue can end in costly repairs or even
                    total breakdown.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 text-[1.3rem] border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
              </div>
              {/* second */}
              <div className=" flex lg:flex-row md:flex-col-reverse flex-col-reverse w-full max-h-[50%] my-[4%]  justify-between  ">
                <div className=" lg:text-start md:text-start sm:text-center lg:min-h-[30%] md:min-h-[10%] my-auto lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] md:text-3xl text-3xl tracking-tight">
                    <b>
                      Materials Define{" "}
                      <span className="text-[#2772AD]">Reliability</span>
                    </b>
                  </p>

                  <p className="leading-normal lg:font-normal text-gray-700    text-[1.3rem]">
                    Not all components are created equal—quality materials
                    withstand heat and wear more effectively. From brake pads to
                    bearings, material affects everything from noise levels to
                    part lifespan. Investing in quality parts today can prevent
                    unexpected failures tomorrow.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
                <div className="lg:w-[50%] md:w-[97%] lg:mb-0 mb-2 h     flex justify-end">
                  <img
                    src={material}
                    alt=""
                    className="rounded-[4%] border-none outline-none box-s lg:w-[31rem]   lg:h-[22rem] md:h-[22rem] h-[17rem]  w-full object-cover  "
                  />
                </div>
              </div>
              {/* third */}
              <div className="flex lg:flex-row md:flex-col flex-col w-full min-h-[50%] my-[4%]    justify-between   ">
                <div className="lg:w-[50%] md:w-[97%] lg:mb-0 mb-2   w-full">
                  <img
                    src={maintenance}
                    alt=""
                    className="rounded-[4%]   lg:w-[31rem]  lg:h-[22rem] md:h-[22rem] h-[17rem] w-full object-cover  "
                  />
                </div>

                <div className=" lg:text-start md:text-start sm:text-center my-auto  lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] md:text-3xl text-3xl tracking-tight">
                    <b>
                      Don’t Delay{" "}
                      <span className="text-[#2772AD]">Maintenance</span>
                    </b>
                  </p>

                  <p className="leading-normal lg:font-normal text-gray-700    text-[1.3rem]">
                    Checking oil, coolant, and fluid levels might seem small—but
                    they’re vital to engine health. Dirty fluids can damage
                    internal parts, reduce performance, and shorten engine life.
                    Routine fluid checks are a simple habit that can save you
                    from costly engine repairs.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
              </div>
              {/* forth */}
              {/* <div className="flex lg:flex-row md:flex-row flex-col-reverse w-full min-h-[30%] my-[3%]    justify-between   dark:bg-gray-800 dark:border-gray-700">
                <div className=" text-start md:text-start sm:text-center lg:mt-0 mt-3   lg:w-[50%] md:w-[50%] w-[100%]">
                  <p className="lg:text-3xl md:text-3xl text-[1.44rem]">
                    <b>Braking Is Not Just About Stopping—It’s About Control</b>
                  </p>

                  <p className="leading-normal lg:font-normal text-gray-700  lg:text-[1.4rem] text-xl">
                    Your brake system is your first line of defense on the road.
                    Worn-out rotors or low-grade pads can reduce stopping power
                    and increase stopping distance. Precision brakes mean faster
                    response, smoother deceleration, and greater confidence
                    behind the wheel. Choose components designed for safety,
                    performance, and longevity—even under stress.
                  </p>
                </div>
                <div className="lg:w-[50%] md:w-[50%]   w-full  flex justify-end">
                  <img
                    src={break4}
                    alt=""
                    className="rounded-xl lg:w-[85%]  lg:h-[93%] w-full object-cover  "
                  />
                </div>
              </div> */}
            </div>

            {/* <div className="w-full px-3">
              <div className="px-2">
                <p className="text-blue-900 font-bold text-2xl md:text-3xl mb-2">
                  Expert Brake Repairs & Replacements
                </p>
                {/* <p className="text-lg md:text-xl mb-3">We offer a complete set of services to keep your brakes reliable and responsive.</p> */}
            {/* </div>
              {[
                "Drum and rotor replacement",
                "Brake pad replacement",
                "Brake system bleeding and fluid flush",
                "Master cylinder replacement",
                "Parking brake repairs",
                "Complete system diagnostics",
              ].map((category, idx) => (
                <span
                  key={idx}
                  className="p-2 text-blue-900  text-[1.4rem]  font-semibold rounded-xl cursor-pointer hover:bg-blue-200 transition flex   items-center"
                >
                  <img src={check} className="h-6 w-6" />
                  {category}
                </span>
              ))}
            </div>  */}
          </div>
          {/* <div className="lg:pt-10 ">
            <Link to="/contact-us">
              {/* <button className="w-full flex justify-center items-center px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white text-lg font-semibold rounded-full transition">
                    Get a FREE Estimate today <FaArrowRight className="ml-3" />
                  </button> */}
          {/* <MyButton
                text="Get a FREE Estimate today"
                className=" flex justify-center items-center  px-2 py-3 bg-blue-600 mx-auto  text-white text-lg font-semibold rounded-full transition"
              />
            </Link>
          </div>  */}
        </div>

        <div
          className="bg-gray-50 bg-cover  h-[25rem] text-white object-contain"
          style={{ backgroundImage: `url(${overlay})` }}
        >
          <div className="bg-black bg-opacity-50 lg:px-4 px-2 lg:py-[100px] py-[60px] flex flex-col items-center justify-center text-center ">
            <h1 className="font-bold text-3xl md:text-4xl lg:text-5xl lg:my-3 my-0 tracking-wide">
              Brakes Affect More Than Just Stopping
            </h1>
            <p className="mb-3 text-white mt-3 lg:text-xl md:text-xl max-w-[56rem] tracking-tight">
              Your brake system doesn’t just stop your car—it affects fuel
              efficiency, tire wear, and suspension health. Worn-out brakes
              increase rolling resistance, making your engine work and consuming
              fuel. Poor braking cause tire wear and strain on suspension
              components.
            </p>
            <Link to="/contact-us">
              {/* <button className="bg-orange-500 text-white px-6 py-3 rounded-full text-xl font-bold hover:bg-orange-600 transition">
                Schedule your brake service
              </button> */}
              <MyButton
                text="Schedule Your Services"
                className="transform transition-transform duration-500  hover:scale-105"
              />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
